import { render, staticRenderFns } from "./tag_navigator_item.html?vue&type=template&id=346f079f&"
import script from "./tag_navigator_item.ts?vue&type=script&lang=js&"
export * from "./tag_navigator_item.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports